export const emoji_meh = () => (
  <path
    d="M8 14h8m-7-4h.01M15 10h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
